module.exports = __webpack_public_path__ + "img/logo-white.84158f90.png";